import AscendingIcon from "./ascending.svg?react";
import DescendingIcon from "./descending.svg?react";
import { tw } from "@/utils";

interface TableSortProps {
  isActive: boolean;
  direction: "none" | "ascending" | "descending";
  onSortChange: () => void;
}

export const TableSort = ({
  isActive,
  direction,
  onSortChange,
}: TableSortProps) => {
  return (
    <div
      className="ml-auto flex flex-col items-center gap-[2px] cursor-pointer"
      onClick={onSortChange}
    >
      <AscendingIcon
        className={tw(
          isActive && direction === "ascending"
            ? "stroke-gray-g75"
            : "stroke-gray-g50"
        )}
      />
      <DescendingIcon
        className={tw(
          isActive && direction === "descending"
            ? "stroke-gray-g75"
            : "stroke-gray-g50"
        )}
      />
    </div>
  );
};
